import APIController from '../core-api-controller';

export const fetchUserProfileData = (id) => {
  const path = `${APIController.endpointApi}/client_user/users/${id}`;
  return APIController.getApiCallback(path);
};

export const updateUserApi = (data = {}, userId = '') => {
  const path = `${APIController.endpointApi}/client_user/users/${userId}`;
  return APIController.putCallback(path, data);
};
